export default __webpack_public_path__ + "static/media/priscriptionwrite.72bd396b.svg";